<div
  class="physical-credential d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          (click)="navigateBack()"
        />
      </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="user-title m-auto col-6">
          <app-with-tooltip [showHelpCursor]="true">
            {{ this.formInstance?.name?.value }}
          </app-with-tooltip>
        </span>    
        <span class="modal-title m-auto">{{
          'PHYSICAL_CREDENTIALS' | translate
        }}</span>
      </div>
      <span class="col-2 d-flex flex-row align-items-center pr-2">
        <app-profile-picture
          [name]="profileDetails?.firstName + ' ' + profileDetails?.lastName"
          [userData]="profileDetails"
        >
        </app-profile-picture>
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="pl-1 cross-button pointer-cursor"
          (click)="closeDialog()"
        />
      </span>
    </div>
  </div>
  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <ng-container *ngIf="step === 1 && userCredentials?.length !== 0">
      <app-user-physical-credentials-list
        [userCredentials]="userCredentials"
        (credentials)="setSelectedCredentials($event)"
        [(step)]="step"
      ></app-user-physical-credentials-list>
    </ng-container>

    <ng-container *ngIf="userCredentials?.length === 0 && step === 1">
      <app-no-user-profile-physical-credentials
        [userName]="this.formInstance?.name?.value"
      ></app-no-user-profile-physical-credentials>
    </ng-container>

    <ng-container *ngIf="userCredentials?.length > 0 && step === 2">
      <app-view-user-physical-credentials
        [selectedCredentials]="selectedCredentials"
        [(step)]="step"
      ></app-view-user-physical-credentials>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <app-user-physical-credentials-access
        [selectedCredentials]="selectedCredentials"
      >
      </app-user-physical-credentials-access>
    </ng-container>
  </div>
</div>
